export class LoginModel {
    email: string;
    password: string;
    cartId: string;
    userRole: number;
}
